import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { apiConnectUser } from '../../api';
import SsoCreateForm from './SsoCreateForm';
import {
  cardStyle,
  cardHeaderStyle,
  cardTitleStyle,
  cardContentStyle,
  cardFooterStyle,
  linkStyle,
  errorStyle
} from './styles/SsoCreate.css';
import {formatExternalUrl} from '../../functions/FormatUrl';
import Button from '../common/Button';

export class SsoCreate extends Component {
  componentDidMount() {


    const query = this.props.query;
    if (query != null) {
      this.setIfValid('firstName', query.f);
      this.setIfValid('lastName', query.l);
    }
  }

  setIfValid = (sid, value) => {
    if (value !== undefined && value !== '') {
      this.setState({ [sid]: value });
    }
  };

  handleSubmitClick = e => {
    e.preventDefault();
    let userData = {
      emailAddress: this.props.formData.values.email,
      password: this.props.formData.values.password,
      firstName: this.props.formData.values.firstName,
      lastName: this.props.formData.values.lastName,
      appId: this.props.tokenData.appId,
      clientId: this.props.tokenData.clientId,
      userId: this.props.tokenData.userId,
      officeId: this.props.tokenData.officeId,
      userGuid: this.props.tokenData.userGuid,
      officeGuid: this.props.tokenData.officeGuid
    };

    this.props.requestConnectUser(
      this.props.query.t, //token
      userData,
      this.props.query.c //app callback
    );
  };

  handelRedirect = e => {
    e.preventDefault();
    window.location.href = this.props.query.r;
  }

  render() {
    const autofillData = {
      firstName:
        this.props.query && this.props.query.f ? this.props.query.f : '',
      lastName: this.props.query && this.props.query.l ? this.props.query.l : ''
    };

    const redirect =
        this.props.redirectUrl ? <Redirect to={this.props.redirectUrl + this.props.match.params.passedInfo} push/> : null;

    const errorMessage = () => {
      const {responseError, tokenData, query} = this.props;

      if (responseError && responseError.status) {
        switch (responseError.status) {
          case 409:
            return (
              <label style={errorStyle}>
                This Lone Wolf Account email is already linked to this{' '}
                {tokenData.appName} account.{' '}
                <br/>
                <a href={formatExternalUrl(query.r)}>
                  Please log in to {tokenData.appName}
                </a>{' '}
                using your Lone Wolf Account email.
              </label>
            );
          case 422:
            return <label style={errorStyle}>{responseError.message}</label>
          default:
            return <label style={errorStyle}>Unknown error.</label>;
        }
      } else {
        return null;
      }
    };

    if (!this.props.query)
      //Don't render form until on mount
      return <p />;
    else
      return (
        <Fragment>
          <div className="container content">
            {redirect}
            <br />
            <div className="card" style={cardStyle}>
              <div className="card-body">
                <div style={cardHeaderStyle}>
                  <div className="card-title" style={cardTitleStyle}>
                    Create Lone Wolf Account
                  </div>
                  <div>
                    Please create your Lone Wolf Account below.
                  </div>
                  <div>
                    If you already have a Lone Wolf Account (if you already log into Back Office using an email address) please choose "Link Account" below.
                  </div>
                  <div>
                    {`You may use any email address, including your ${
                      this.props.tokenData.appName
                    } email.`}
                  </div>
                </div>
                <div style={cardContentStyle}>
                  <SsoCreateForm
                    apiError={errorMessage()}
                    handleSubmit={this.handleSubmitClick}
                    initialValues={autofillData}
                  />
                </div>
                <hr />
                <div style={cardFooterStyle}>
                  <span>
                    Already have an Lone Wolf Account?{' '}
                    <Link
                      to={
                        '/register/sso-link/' +
                        this.props.match.params.passedInfo
                      }
                      style={linkStyle}
                    >
                      Link Account
                    </Link>
                  </span>
                </div>
                <div className="row justify-content-center text-center">
                  <Button
                    action={this.handelRedirect}
                    text={'Skip for Now'}
                  />
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
  }
}

const mapStateToProps = state => ({
  responseStatus: state.signupReducer.auth,
  responseError: state.signupReducer.err,
  query: state.initial.queryInfo,
  tokenData: state.initial.tokenData,
  formData: state.form.SsoCreate,
  redirectUrl: state.signupReducer.nextPage,
});

const mapDispatchToProps = dispatch => ({
  requestConnectUser: (token, request, appCallback) =>
    dispatch(apiConnectUser(token, request, appCallback))
});

export default connect(mapStateToProps, mapDispatchToProps)(SsoCreate);
